import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const MultiPromptBuilderPage = loadAsyncComponent(() => import('./Container'), 'page');
